// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Sortable from 'sortablejs'
import store from './vuex/store'
import VueMaterial from 'vue-material'
import Vuelidate from 'vuelidate'

Vue.directive('sortable', {
	inserted: function (el, binding) {
		new Sortable(el, binding.value || {})
	}
})
Vue.use(VueMaterial)
Vue.use(Vuelidate)

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    showCommonMessage (message) {
      this.$root.$children[0].showMessage(message)
    }
  }
})

Vue.mixin({
  methods: {
    handleError (err) {
      if (err.status === 401) {
        this.$root.$children[0].logout()
      } else {
        this.showCommonMessage(err.message)
        console.log(err)
      }
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js